<template>
	<section class="grid-col" :class="[ 'mb-'+ mb, 'mt-'+ mt, 'col-' + size, screen]">
		<slot />
	</section>
</template>

<script>
	export default {
		name: 'grid-col',
		props:{
			mb: {
				type: String,
				required: false,
				default: '0',
			},
			mt: {
				type: String,
				required: false,
				default: '0',
			},
			size: {
				type: String,
				required: false,
				default: '0',
			},
			screen: {
				type: String,
				required: false,
				default: '',
			}
		}
	};
</script>



